import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Move the RoutePlan to next revision
 *
 * @private
 */
export const goToNextRevision = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/transaction/gotoNext', async (_, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/transaction/gotoNextRevision', {
      category: 'rpc',
      type: 'rpc/transaction/gotoNextRevision',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {goToNextRevision}`,
      { tags: ['rpc', 'transaction'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Go to previous revision  Failed`,
      error,
    })
  }
})
